import { intlShape } from 'react-intl';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import { pickContextTypes } from '../../context-types';

import Icon from 'widget/player-widget/components/icon/icon';
import ControlButton from '../../control-button/control-button';

import styles from './fullscreen.styl';

import translations from './translations';


@WixConnect(styles)
export default class Fullscreen extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
    intl: intlShape,
  };

  static contextTypes = pickContextTypes('toggleFullScreenByUser', 'fullScreen');

  render() {
    const { className, intl: { formatMessage } } = this.props;
    const { toggleFullScreenByUser, fullScreen } = this.context;

    const iconName = fullScreen ? 'exit-fullscreen' : 'fullscreen';
    const iconNameHover = `${iconName}-hover`;

    return (
      <ControlButton styleName="fullscreen-button"
                     className={className}
                     onClick={toggleFullScreenByUser}
                     tooltip={{
                       content: formatMessage(translations.enter),
                       position: 'left',
                     }}>
        <Icon styleName={`icon icon-${iconName}`}
              name={iconName} />
        <Icon styleName={`icon icon-${iconNameHover}`}
              name={iconNameHover} />
      </ControlButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/controls/fullscreen/fullscreen.js